import { render } from "./ListaUsuariosView.vue?vue&type=template&id=cfe8f836"
import script from "./ListaUsuariosView.vue?vue&type=script&lang=js"
export * from "./ListaUsuariosView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__